<template>
  <div class="facets-type-range">
    <div class="facets-type-checkbox__title">{{ title }}</div>
    <div class="facets-type-checkbox__result">
      {{ values.join(' - ') | decimalSeparator }}
    </div>
    <div class="facets-type-range__body">
      <input
        ref="facetsRangeMin"
        :value="selectedValues.min"
        :min="minimalValue"
        :max="maximumValue"
        step="0.5"
        type="range"

        class="facets-type-range__input"

        @input="updateValues"
      />
      <input
        ref="facetsRangeMax"
        :value="selectedValues.max"
        :min="minimalValue"
        :max="maximumValue"
        step="0.5"
        type="range"

        class="facets-type-range__input"

        @input="updateValues"
      />
    </div>
</div>
</template>

<script>
export default {
  name: 'FacetsTypeRange',

  props: {
    type: {
      type: Array,
      required: true,
    },

    name: {
      type: Array,
      required: false,
      default: () => [],
    },

    options: {
      type: Object,
      required: true,
    },

    minValue: {
      type: Number,
      required: false,
      default: null,
    },

    maxValue: {
      type: Number,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      values: [],
      selectedValues: {
        min: 0,
        max: 0,
      },
    };
  },

  computed: {
    title() {
      return this.name[0] || this.type[0];
    },

    allValues() {
      return this.options[this.type[0]].map((option) => Number(option.value));
    },

    minimalValue() {
      if (this.minValue !== null) {
        return this.minValue;
      }

      return Math.min(...this.allValues);
    },

    maximumValue() {
      if (this.maxValue !== null) {
        return this.maxValue;
      }

      return Math.max(...this.allValues);
    },
  },

  mounted() {
    this.selectedValues.min = this.minimalValue;
    this.selectedValues.max = this.maximumValue;

    this.setValues();
  },

  methods: {
    updateValues() {
      const minValue = this.$refs.facetsRangeMin.value;
      const maxValue = this.$refs.facetsRangeMax.value;

      this.selectedValues.min = parseFloat(minValue);
      this.selectedValues.max = parseFloat(maxValue);

      this.setValues();
    },

    setValues() {
      const { min, max } = this.selectedValues;

      if (min > max) {
        this.values = [max, min];
      } else {
        this.values = [min, max];
      }

      this.emitFacet();
    },

    emitFacet() {
      this.$emit('selected', {
        value: [this.values.join(',')],
        key: this.type[0],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .facets-type-range {
    &__body {
      height: 20px;
      max-width: 200px;
      position: relative;
    }

    &__input {
      height: 18px;
      left: 0;
      margin: 0;
      outline: none;
      overflow: hidden;
      padding: 0;
      pointer-events: none;
      position: absolute;
      right: 0;
      top: 0;

      &::-webkit-slider-thumb {
        outline: 0;
        pointer-events: all;
        position: relative;
        z-index: get-z-index('.facets-type-range__input');
      }

      &::-moz-range-thumb {
        -moz-appearance: none;
        pointer-events: all;
        position: relative;
        width: 9px;
        z-index: get-z-index('.facets-type-range__input');
      }

      &::-moz-range-track {
        background-color: rgba(0, 0, 0, 1);
        border: 0;
        position: relative;
        z-index: -1;
      }

      &::-moz-focus-outer {
        border: 0;
      }

      &:last-of-type::-moz-range-track {
        -moz-appearance: none;
        background: none transparent;
        border: 0;
      }
    }
  }
</style>
